import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { sync } from "vuex-router-sync";
import vuetify from "./plugins/vuetify";
import VeeValidate from "vee-validate";
import { Validator } from "vee-validate";
import inPast from "./validationRules/inPast";
import date from "./validationRules/date";
import VueMoment from "vue-moment";
import { VueHammer } from "vue2-hammer";
import "nprogress/nprogress.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "./styles/site.scss";
import { logDetailed } from "./helpers/utils";
import colorThemeMixin from "./components/mixins/ColorThemeMixin";
window.__webpack_public_path__ = window.clientBaseURL || process.env.VUE_APP_CLIENT_BASEURL || "/";

logDetailed("main", "root", "entering main");

Validator.extend("inPast", inPast);
Validator.extend("date", date);
Vue.use(VeeValidate, {
  inject: true,
  events: "change",
  fieldsBagName: "veeFields"
});

Vue.use(VueMoment);
Vue.use(VueHammer);
Vue.mixin(colorThemeMixin);

Vue.config.productionTip = false;

sync(store, router);

if (document.addEventListener)
{
 document.addEventListener('fullscreenchange', exitHandler, false);
 document.addEventListener('mozfullscreenchange', exitHandler, false);
 document.addEventListener('MSFullscreenChange', exitHandler, false);
 document.addEventListener('webkitfullscreenchange', exitHandler, false);
}

function exitHandler()
{
 if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement)
  store.commit("resetFullscreen");
}

var preLoadTask = store.dispatch("initialize");

preLoadTask.finally(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount("#app");
});